import { render, staticRenderFns } from "./FeedBackOnekidsDetail.vue?vue&type=template&id=72d19d48&scoped=true"
import script from "./FeedBackOnekidsDetail.vue?vue&type=script&lang=js"
export * from "./FeedBackOnekidsDetail.vue?vue&type=script&lang=js"
import style1 from "./FeedBackOnekidsDetail.vue?vue&type=style&index=1&id=72d19d48&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72d19d48",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/VsAMsifqL/0/hero/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('72d19d48')) {
      api.createRecord('72d19d48', component.options)
    } else {
      api.reload('72d19d48', component.options)
    }
    module.hot.accept("./FeedBackOnekidsDetail.vue?vue&type=template&id=72d19d48&scoped=true", function () {
      api.rerender('72d19d48', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/master/notify/FeedBackOnekidsDetail.vue"
export default component.exports